module.exports = __webpack_public_path__ + "img/banner-product-shadow.4b650e42.png";